import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  getActiveUserPage,
  deleteNewUser,
  getActiveUsers,
} from "../Redux/Actions/Useraction";
import { Table, Modal, Button } from "react-bootstrap";
import Paginationcomponent from "./pagination";
import notify from "../Hook/useNotification";
import { useTranslation } from "react-i18next";

const AllActiveUsers = ({ keyword }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [Deleteloading, setDeleteLoading] = useState(true);

  useEffect(() => {
    dispatch(getActiveUsers(10, keyword));
  }, [dispatch, keyword]);

  const handleClose = () => {
    setShow(false);
    setDeleteId(null);
  };
  const handleShow = (id) => {
    setDeleteId(id);
    setShow(true);
  };

  const usersData = useSelector((state) => state.alluser.activeusers);
  console.log("activeusers", usersData);

  const loading = useSelector((state) => state.alluser.loading);

  const getpage = (page) => {
    dispatch(getActiveUserPage(page));
  };
  let pagecount = 0;
  if (usersData?.pagination?.numberOfPages) {
    pagecount = usersData?.pagination?.numberOfPages;
  }

  const ActiveUsers = usersData?.data?.users || [];

  const handleDeleteConfirmed = async () => {
    setDeleteLoading(true);
    await dispatch(deleteNewUser(deleteId));
    setDeleteLoading(false);
    handleClose();
  };

  const res = useSelector((state) => state.alluser.deletenewuser);
  console.log("deleteRes", res);
  useEffect(() => {
    if (Deleteloading === false) {
      if (res?.message === "User deactivated successfully") {
        notify(t("opticianTab.notify.delete_success"), "success");
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } else {
        notify(t("opticianTab.notify.delete_error"), "error");
      }
      setDeleteLoading(true);
    }
  }, [Deleteloading, res?.message, t]);

  return (
    <>
      {loading ? (
        <p>{t("opticianTab.loading")}</p>
      ) : ActiveUsers.length === 0 ? (
        <p>{t("opticianTab.no_opticians")}</p>
      ) : (
        <Table striped bordered hover>
          <thead className="table-dark">
            <tr>
              <th>{t("opticianTab.table.name")}</th>
              <th>{t("opticianTab.table.email")}</th>
              <th>{t("opticianTab.table.role")}</th>
              <th>{t("opticianTab.table.actions")}</th>
            </tr>
          </thead>
          <tbody>
            {ActiveUsers.map((optician, index) => (
              <tr key={index}>
                <td>{optician.firstName + " " + optician.lastName}</td>
                <td>{optician.email}</td>
                <td>{optician.role}</td>
                <td>
                  <FaTrash
                    style={{ cursor: "pointer", color: "#dc3545" }}
                    onClick={() => handleShow(optician._id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      {pagecount > 1 && (
        <Paginationcomponent pagecount={pagecount} onpress={getpage} />
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{t("opticianTab.modal.delete.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("opticianTab.modal.delete.body")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("opticianTab.modal.cancel")}
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirmed}>
            {t("opticianTab.modal.delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AllActiveUsers;
